import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { ORG_URL } from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import AppTableView from "../../AppTableView";
import OrgDialog from "./OrgDialog";

function Organization() {


  const [orgs, setOrgs] = useState([]);

  useEffect(() => {
    getOrgs();
  }, []);

  const getOrgs = () => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(ORG_URL).then((response) => setOrgs(response.data.data));
  };


  return (
    <Container fluid style={{ display: "flex", flexDirection: "column" }}>
      <Box>
        <OrgDialog
          orgId={0}
          data={orgs}
          selectedOrgName={""}
          callOrgs={getOrgs}
          isEdit={false}
        />
      </Box>
      <AppTableView
        rows={orgs}
        cols={[
          /* { field: "id", headerName: "Org ID", flex: 0.5 }, */
          {
            field: "name",
            headerName: "Name",
            flex: 1,
            renderCell: (params) => (
              <OrgDialog
                orgId={params.row.id}
                data={orgs}
                selectedOrgName={params.row.name}
                callOrgs={getOrgs}
                isEdit={true}
              />
            ),
          },
          { field: "organizationType", headerName: "Organization Type", flex: 1, renderCell: (params) => params.row ?.organizationType ?.name },
          { field: "webSite", headerName: "WebSite", flex: 1 },
          {
            field: "parent",
            headerName: "IsParent?",
            flex: 1,
            renderCell: (params) => (params.row ?.parent ? "Yes" : "No"),
          },
        ]}
        initialPageSize={15}
      />
    </Container>
  );
}

export default Organization;
